import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import GameSelectorModal from "../../components/GameSelectorModal";
import GameTypeModal from "../../components/GameTypeModal";
import { useNavigate } from "react-router-dom";
import { GAME_MODES, getSessionType, MODE_SELECTOR } from "behaviour-analyzer-shared";
import { useGameServices } from "../../hooks/useSharedServices";


const GameSelector = () => {
    const { gameSessionService } = useGameServices();
    const [modalOpen, setModalOpen] = useState(false);
    const [gameTypeModalOpen, setGameTypeModalOpen] = useState(false);
    const [selectedMode, setSelectedMode] = useState(null);
    const [activeSession, setActiveSession] = useState(null);
    const navigate = useNavigate();

  const handleModeSelect = async (mode) => {
    setSelectedMode(mode);

    // Obtener o crear sesión (el backend siempre devuelve una sesión)
    const sessionType = getSessionType(mode.value);
    const sessionResult = await gameSessionService.getOrCreateSession(sessionType);

    if (sessionResult.success && sessionResult.data) {
      const session = sessionResult.data;
      setActiveSession(session);
      
      // Usar el campo wasJustCreated para decidir el flujo
      if (session.wasJustCreated) {
        // Sesión recién creada -> ir directamente al juego como nueva partida
        navigate("/jugar", { state: { modality: mode.title, isNewGame: true } });
      } else {
        // Sesión existente -> mostrar modal para elegir continuar o nueva partida
        setGameTypeModalOpen(true);
      }
    } else {
      // Error al obtener sesión, navegar de todos modos
      navigate("/jugar", { state: { modality: mode.title, isNewGame: true } });
    }
  };

  const handleSelectGameType = async (isNewGame) => {
    setGameTypeModalOpen(false);
    
    // Si el usuario elige "Nueva partida" y hay una sesión activa, cerrarla
    if (isNewGame && activeSession) {
      await gameSessionService.closeSession(activeSession.id);
      setActiveSession(null);
    }
    
    navigate("/jugar", { state: { modality: selectedMode.title, isNewGame } });
  };

  const handleInfo = (mode) => {
    setSelectedMode(mode);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedMode(null);
  };

  return (
    <div
      style={{
        backgroundColor: "#f5f5f5",
        padding: "40px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: 1,
      }}
    >
      {/* Título y descripción */}
      <h1
        style={{
          color: "#333",
          fontSize: "2rem",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        {MODE_SELECTOR.title}
      </h1>
      <p
        style={{
          color: "#666",
          fontSize: "1rem",
          textAlign: "center",
          marginBottom: "40px",
          maxWidth: "600px",
        }}
      >
        {MODE_SELECTOR.subtitle}
      </p>

      {/* Contenedor de botones */}
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          display: "flex",
          flexDirection: "column",
          gap: "30px",
        }}
      >
        {GAME_MODES.map((mode, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* Botón para seleccionar el modo */}
            <button
              onClick={() => handleModeSelect(mode)}
              style={{
                width: "100%",
                padding: "20px",
                backgroundColor: mode.color,
                border: "none",
                borderRadius: "8px",
                color: "#fff",
                fontSize: "1.2rem",
                cursor: "pointer",
                transition: "transform 0.4s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.4)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  {mode.title}
                </span>
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{
                    fontSize: "1.2rem",
                    color: "#fff",
                    cursor: "pointer",
                    position: "absolute",
                    right: 0,
                    zIndex: 10,
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); // Evita que se dispare el onClick del botón principal
                    handleInfo(mode);
                  }}
                />
              </div>
            </button>
          </div>
        ))}
      </div>

      {/* Modal para mostrar la información */}
      {modalOpen && selectedMode && (
        <GameSelectorModal isOpen={modalOpen} mode={selectedMode.title} onClose={closeModal} />
      )}
      
      {/* Modal para elegir tipo de juego (continuar/nueva partida) */}
      {gameTypeModalOpen && selectedMode && (
        <GameTypeModal 
          isOpen={gameTypeModalOpen}
          onClose={() => {
            setGameTypeModalOpen(false);
            setSelectedMode(null);
            setActiveSession(null);
          }}
          onSelectNewGame={() => handleSelectGameType(true)}
          onSelectContinue={() => handleSelectGameType(false)}
          modeTitle={selectedMode?.title || ""}
        />
      )}
    </div>
  );
};

export default GameSelector;
